import {UIGameEndReturnToMapButtonController} from './UIGameEndReturnToMapButtonController'
import {UIGameEndFooterController} from './UIGameEndFooterController'
import {UIGameManager} from '../UIGameManager'
import {StorageWrapper} from '../../StorageWrapper'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {UIGameEndShareButtonController} from './UIGameEndShareButtonController'
import {EndGamePlayerState, EndGameState, PlayerColor} from '@colonist/game-states'
import {EndGameStateUtils} from '@colonist/game-endgame-types'
import {EndGameRankedUserState, RankedUserStateController} from '@colonist/leaderboard-types'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {setGlobalGameEndProviderProps} from '@colonist/ui-game'
import {EndGameRankedUserStateTransferObject} from '@colonist/game-base-types'
import {UIReplayShareController} from '../../ui_replay/UIReplayShareController'
import {UIEndGameShareImage} from '../../ui_share_image/UIEndGameShareImage'

export class UIGameEndController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    readonly endGameState: EndGameState
    protected readonly isReplayAvailable: boolean
    protected readonly winnerColor: PlayerColor
    readonly rankedUserStates: EndGameRankedUserState[] | undefined
    protected readonly isShownAfterLiveGame: boolean

    returnToMapController: UIGameEndReturnToMapButtonController
    protected shareButton: UIGameEndShareButtonController
    protected footerController: UIGameEndFooterController

    constructor(uiGameManager: UIGameManager, endGameState: EndGameState, isReplayAvailable: boolean, rankedUserStates: EndGameRankedUserStateTransferObject[] | undefined, isShownAfterLiveGame: boolean | undefined) {
        this.uiGameManager = uiGameManager
        this.winnerColor = EndGameStateUtils.getPlayersSortedByRank(endGameState.players)[0].color
        this.isShownAfterLiveGame = isShownAfterLiveGame ?? true

        const isRankedUserStateDefined = rankedUserStates != undefined && rankedUserStates.length != 0
        if(isRankedUserStateDefined) {
            const deserializedRankedUserState: EndGameRankedUserState[] = []
            for(const rankedUserState of rankedUserStates) {
                deserializedRankedUserState.push({
                    color: rankedUserState.color,
                    rankedState: RankedUserStateController.deserialize(rankedUserState.rankedState),
                })
            }

            this.rankedUserStates = deserializedRankedUserState
        }

        this.endGameState = endGameState
        this.isReplayAvailable = isReplayAvailable
        this.returnToMapController = new UIGameEndReturnToMapButtonController(this.uiGameManager, this)
        this.shareButton = new UIGameEndShareButtonController(this.uiGameManager, this)
        this.footerController = new UIGameEndFooterController(this.uiGameManager)

        this.setEndGameShareImageHumanSessions()

        setGlobalGameEndProviderProps({
            onClickHome: () => this.footerController.onClickHome(),
            onClickRematch: () => this.footerController.onClickRematch(),
            onClickPlayAgain: () => this.footerController.onClickPlayAgain(),
            onClickRetryBeginnerMode: () => this.footerController.onClickRetryBeginnerMode(),
            onClickNextLevelBeginnerMode: () => this.footerController.onClickNextLevelBeginnerMode(),
            onClickShare: () => this.shareButton.onClickShare(),
            onClickStatsOrReplay: () => this.returnToMapController.onClickButton(),
            onEndGameScreenOpen: () => this.onEndGameScreenOpen(),
            onEndGameScreenClose: () => this.onEndGameScreenClose(),
            gameEndData: {
                endGameState: this.endGameState,
                rankedUserStates: this.rankedUserStates,
                isReplayAvailable: this.isReplayAvailable,
            },
            numberOfPlayersJoinedRematch: 0,
            isAfterLiveGame: this.isShownAfterLiveGame,
        })

        this.uiGameManager.gameStore.getState().gameEnd.setEndControls({
            onClickStatsOrReplay: () => this.returnToMapController.onClickButton(),
            onClickShareReplay: () => UIReplayShareController.shareOrCopyLink(this.uiGameManager.gameController),
        })

        this.uiGameManager.gameStore.getState().gameEnd.setIsVisible(true)

        this.onEndGameScreenOpen()
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.BeginnerModeLevelEnd: this.onBeginnerModeLevelEnd(data); break
            default: break
        }
    }

    onEndGameScreenClose() {
        this.uiGameManager.mapController.setInteractionEnabled(true)
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.GameEndShowMap)
    }

    onEndGameScreenOpen() {
        this.uiGameManager.mapController.setInteractionEnabled(false)
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.GameEndHideMap)
    }

    // eslint-disable-next-line class-methods-use-this
    private onBeginnerModeLevelEnd(data: BeginnerModeActionState) {
        StorageWrapper.incrementBeginnerModeLevel()
    }

    setVisible(state: boolean) {
        if(state) {
            this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.GameEndHideMap)
        } else {
            this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.GameEndShowMap)
        }
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }

    get isVisible(): boolean {
        return this.uiGameManager.gameStore.getState().gameEnd.isVisible
    }

    get endGamePlayerState(): EndGamePlayerState | undefined {
        return this.endGameState.players[this.uiGameManager.gameController.myColor]
    }

    private setEndGameShareImageHumanSessions() {
        const playerColors = this.uiGameManager.gameController.getPlayerColors()
        for(const color of playerColors) {
            const player = this.uiGameManager.gameController.getPlayerState(color)
            if(player.isActiveHumanSession) UIEndGameShareImage.activeHumansAtGameEnd.add(color)
        }
    }
}
